import { setUpModernPage } from 'js/simple_layout/set_up_modern_page';
setUpModernPage();

import registerForRails from 'js/utils/registerForRails';
import { trackClick } from 'js/utils/trackClick';
import { currentUser } from 'js/utils/user';

import { setUpFigureCarousel } from 'js/single_work/loswp/setUpFigureCarousel';
import { initializeResearchInterestFollowButtons } from 'js/research_interest_directory/research_interest_follow_buttons';
import { setUpTruncateComponent } from 'js/single_work/loswp/setUpTruncateComponent';
import { LoginModalManager } from 'js/login_modal/LoginModalManager';
import { setUpThirdPartySignIn } from 'js/login_modal/setUpThirdPartySignIn';
import ResearchInterestDirectorySearch from 'js/research_interest_directory/ResearchInterestDirectorySearch';

registerForRails({ LoginModalManager, ResearchInterestDirectorySearch });

declare global {
  interface Window {
    topicId?: number;
  }
}

const loginButtonConfigs = {
  'login-button--header': {
    buttonsPage: {
      header: 'Follow topics, advance your research',
      subheader: 'Sign up to get access to over 50M papers',
    },
  },
  'join-us-banner--topics': {
    buttonsPage: {
      header: 'Join our community of curious minds',
      subheader:
        'Sign up to download 50M+ research papers and connect with fellow researchers',
    },
  },
};

function setUpCustomLoginButtons() {
  setUpThirdPartySignIn();

  const loginButtons = document.querySelectorAll('.react-login-modal-opener');

  loginButtons.forEach((button) => {
    button.addEventListener('click', (e) => {
      e.preventDefault();

      const dataAttribute = button.getAttribute('data-signup-modal');
      if (!dataAttribute) return;

      const data = JSON.parse(dataAttribute);
      const location = data.location;

      const configuredText = loginButtonConfigs[
        location as keyof typeof loginButtonConfigs
      ] ?? {
        buttonsPage: {
          header: 'Follow topics, advance your research',
          subheader: 'Sign up to get access to over 50 million papers',
        },
      };

      document.dispatchEvent(
        new CustomEvent('open-login-modal', {
          detail: {
            clickTrackingContext: {
              source: `topics--${location}`,
              entityId: window.topicId,
            },
            configuredText,
            registrationParams: {
              user_source: 'download',
            },
          },
        }),
      );
    });
  });
}

window.addEventListener('DOMContentLoaded', () => {
  if (currentUser) {
    initializeResearchInterestFollowButtons();
  } else {
    setUpCustomLoginButtons();
  }

  // Set up click tracking for all nav items and buttons
  document.querySelectorAll('[data-click-track]').forEach((el) => {
    el.addEventListener('click', () => {
      const source = el.getAttribute('data-click-track');
      if (source) {
        trackClick({
          source,
          entityId: window.topicId,
        });
      }
    });
  });

  setUpFigureCarousel();

  // This is LOSWP functionality, but it's convenient to use for topic definition truncation
  setUpTruncateComponent('topic-definition-mobile', 5, ['small']);
});
